module.exports = "<div data-bind=\"foreach: {data: dataList, as: 'col'}\">\n  <!-- ko if: col.type -->\n  <!-- ko if: col.type == 'render' -->\n  <div class=\"text-left\" data-bind=\"html: col.renderFn(row),style:col.style\">\n  </div>\n  <!-- /ko -->\n  <!-- ko if: col.type == 'component' -->\n  <div class=\"text-left\" data-bind=\"component: col.compFn(row),style:col.style\">\n  </div>\n  <!-- /ko -->\n  <!-- /ko -->\n  <!-- ko ifnot: col.type -->\n  <div class=\"text-left\" data-bind=\"text: $parent.defaultFormatText(row, col)\"></div>\n  <!-- /ko -->\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/grid/mergetd.html
// module id = 412
// module chunks = 0